import { render } from "./DJvirtualCommerce.vue?vue&type=template&id=154d4d88&scoped=true"
import script from "./DJvirtualCommerce.vue?vue&type=script&lang=js"
export * from "./DJvirtualCommerce.vue?vue&type=script&lang=js"

import "./DJvirtualCommerce.vue?vue&type=style&index=0&id=154d4d88&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-154d4d88"

export default script